import { Formatter } from './formatter';
import { EditorManager } from './../../editor-manager/base/editor-manager';
import { extend } from '@syncfusion/ej2-base';
import { htmlKeyConfig } from './../../common/config';
/**
 * HTML adapter
 *
 * @hidden
 * @deprecated
 */
export class HTMLFormatter extends Formatter {
    constructor(options) {
        super();
        this.initialize();
        extend(this, this, options, true);
        if (this.currentDocument && this.element) {
            this.updateFormatter(this.element, this.currentDocument, options.options, options.formatPainterSettings, options.enterAction);
        }
    }
    initialize() {
        this.keyConfig = htmlKeyConfig;
    }
    /**
     * Update the formatter of RichTextEditor
     *
     * @param {Element} editElement - specifies the edit element.
     * @param {Document} doc - specifies the doucment
     * @param {number} options - specifies the options
     * @param {FormatPainterSettingsModel} formatPainterSettings - specifies the format painter settings
     * @param {EnterKey} enterAction - Specifies the enter key configuration of editor
     * @returns {void}
     * @hidden
     * @deprecated
     */
    updateFormatter(editElement, doc, options, formatPainterSettings, enterAction) {
        if (editElement && doc) {
            this.editorManager = new EditorManager({
                document: doc,
                editableElement: editElement,
                options: options,
                formatPainterSettings: formatPainterSettings,
                enterAction: enterAction
            }, false);
        }
    }
}
